"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionLocation24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 24, viewBox: "0 0 30 24" }, props),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { fill: "#F6F7F8", d: "M0 2.005C0 .898.898 0 1.992 0h26.016C29.108 0 30 .897 30 2.005v19.99C30 23.102 29.102 24 28.008 24H1.992C.892 24 0 23.103 0 21.995V2.005z" }),
            react_1.default.createElement("rect", { width: 24, height: 10, x: 3, y: 7, fill: "#CDD8FF", fillRule: "nonzero", rx: 1 }),
            react_1.default.createElement("path", { fill: "#698AFF", fillRule: "nonzero", d: "M15.5 3c4.142 0 7.5 3.38 7.5 7.549 0 2.78-2.5 6.374-7.5 10.784-5-4.41-7.5-8.005-7.5-10.784C8 6.379 11.358 3 15.5 3zm0 1.667c-3.22 0-5.833 2.63-5.833 5.882 0 1.979 1.91 4.889 5.833 8.537 3.922-3.648 5.833-6.558 5.833-8.537 0-3.251-2.614-5.882-5.833-5.882zm0 2.5c1.84 0 3.333 1.492 3.333 3.333 0 1.84-1.492 3.333-3.333 3.333-1.84 0-3.333-1.492-3.333-3.333 0-1.84 1.492-3.333 3.333-3.333zm0 1.666c-.92 0-1.667.747-1.667 1.667s.747 1.667 1.667 1.667 1.667-.747 1.667-1.667-.747-1.667-1.667-1.667z" })));
}
function QuestionLocation24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionLocation24Svg, Object.assign({}, svgProps)));
}
exports.default = QuestionLocation24;
//# sourceMappingURL=QuestionLocation24.js.map